import { PropsWithChildren } from 'react'

function Title({ className, children }: PropsWithChildren<{ className?: string }>) {
  return <div className={`text-brand-1 text-xl font-bold ${className}`}>{children}</div>
}

export default Title
